import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { SystemService } from '../../services/system.service';
import { CdkPortalOutlet, DomPortalOutlet, TemplatePortal } from '@angular/cdk/portal';
import { MOBILE_HEADER_PORTAL_RIGHT_CONTENT_CONTAINER_ID, MOBILE_HEADER_PORTAL_UNDER_CONTENT_CONTAINER_ID } from './admin-layout.component';


@Injectable({
  providedIn: 'root'
})
export class AdminLayoutService implements OnDestroy {

  private secondaryContentPortalOutlet: CdkPortalOutlet | undefined;
  secondaryContentAttached$ = new BehaviorSubject<boolean>(false);
  showPrimaryContent$ = new BehaviorSubject<boolean>(true);
  showSecondaryContent$ = new BehaviorSubject<boolean>(false);
  secondaryContentHid$ = new Subject<void>();

  private mobileHeaderUnderContentOutlet: DomPortalOutlet | undefined;
  private mobileHeaderUnderContentPortal: TemplatePortal | undefined;

  private mobileHeaderRightContentOutlet: DomPortalOutlet | undefined;
  private mobileHeaderRightContentPortal: TemplatePortal | undefined;


  showContentPadding$ = new BehaviorSubject<boolean>(true);

  subs: Subscription[] = [];

  constructor(
    private sysService: SystemService,
    private cfr: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
  ) { }

  attachMobileHeaderRightContent(content: TemplateRef<any> | undefined, vcr: ViewContainerRef) {
    const container = document.getElementById(MOBILE_HEADER_PORTAL_RIGHT_CONTENT_CONTAINER_ID);
    if (!container || !content) return;

    this.mobileHeaderRightContentOutlet = new DomPortalOutlet(
      container,
      this.cfr,
      this.appRef,
      this.injector
    );

    this.mobileHeaderRightContentPortal = new TemplatePortal(content, vcr);

    this.mobileHeaderRightContentOutlet.attach(this.mobileHeaderRightContentPortal)
  }
  detachMobileHeaderRightContent() {
    if (this.mobileHeaderRightContentOutlet?.hasAttached()) {
      this.mobileHeaderRightContentOutlet.detach();
      this.mobileHeaderRightContentPortal = undefined;
      this.mobileHeaderRightContentOutlet = undefined;
    }
  }

  attachMobileHeaderUnderContent(content: TemplateRef<any> | undefined, vcr: ViewContainerRef) {
    const container = document.getElementById(MOBILE_HEADER_PORTAL_UNDER_CONTENT_CONTAINER_ID);
    if (!container || !content) return;

    this.mobileHeaderUnderContentOutlet = new DomPortalOutlet(
      container,
      this.cfr,
      this.appRef,
      this.injector
    );

    this.mobileHeaderUnderContentPortal = new TemplatePortal(content, vcr);

    this.mobileHeaderUnderContentOutlet.attach(this.mobileHeaderUnderContentPortal)
  }
  detachMobileHeaderUnderContent() {
    if (this.mobileHeaderUnderContentOutlet?.hasAttached()) {
      this.mobileHeaderUnderContentOutlet.detach();
      this.mobileHeaderUnderContentPortal = undefined;
      this.mobileHeaderUnderContentOutlet = undefined;
    }
  }

  hideContentPadding() {
    this.showContentPadding$.next(false);
  }
  resetContentPadding() {
    this.showContentPadding$.next(true);
  }

  setSecondaryContentPortalOutlet(outlet: CdkPortalOutlet) {
    this.secondaryContentPortalOutlet = outlet;
  }
  attachSecondaryContent(portal: TemplatePortal) {
    setTimeout(() => {
      this.detachSecondaryContent();
      if (this.secondaryContentPortalOutlet) {
        this.secondaryContentPortalOutlet.attach(portal);
        this.secondaryContentAttached$.next(true);
        if (this.sysService.deviceWidth$.value >= 1200) {
          this.showSecondaryContent$.next(true);
          this.showPrimaryContent$.next(true);
        } else {
          this.showSecondaryContent$.next(true);
          this.showPrimaryContent$.next(false);
        }
      }
    })
  }
  detachSecondaryContent() {
    if (this.secondaryContentPortalOutlet?.hasAttached()) {
      this.secondaryContentPortalOutlet.detach();
      this.secondaryContentAttached$.next(false);
      this.showPrimaryContent$.next(true);
      this.showSecondaryContent$.next(false);
    }
  }

  toggleShowSecondaryContent() {
    if (this.showSecondaryContent$.value) {
      this.hideSecondaryContent();
    } else {
      this.showSecondaryContent();
    }
  }
  showSecondaryContent() {
    this.showSecondaryContent$.next(true);
  }
  hideSecondaryContent() {
    this.showSecondaryContent$.next(false);

    this.secondaryContentHid$.next();
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }
}
